var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewbankicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 58,
    viewBox: "0 0 52 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0.5H37C43.3513 0.5 48.5 5.64873 48.5 12V36C48.5 42.3513 43.3513 47.5 37 47.5H13C6.64873 47.5 1.5 42.3513 1.5 36V12C1.5 5.64873 6.64873 0.5 13 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 0.5H37C43.3513 0.5 48.5 5.64873 48.5 12V36C48.5 42.3513 43.3513 47.5 37 47.5H13C6.64873 47.5 1.5 42.3513 1.5 36V12C1.5 5.64873 6.64873 0.5 13 0.5Z",
    stroke: "#D5D7DA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddi_1140_30797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 12C5 7.58172 8.58172 4 13 4H37C41.4183 4 45 7.58172 45 12V36C45 40.4183 41.4183 44 37 44H13C8.58172 44 5 40.4183 5 36V12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 3.5C41.6944 3.5 45.5 7.30558 45.5 12V36C45.5 40.6944 41.6944 44.5 37 44.5H13C8.30558 44.5 4.5 40.6944 4.5 36V12C4.5 7.30558 8.30558 3.5 13 3.5H37Z",
    stroke: "black",
    strokeOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 21V29M22.5 21V29M27.5 21V29M32 21V29M16 30.6L16 31.4C16 31.9601 16 32.2401 16.109 32.454C16.2049 32.6422 16.3578 32.7952 16.546 32.891C16.7599 33 17.0399 33 17.6 33H32.4C32.9601 33 33.2401 33 33.454 32.891C33.6422 32.7952 33.7951 32.6422 33.891 32.454C34 32.2401 34 31.9601 34 31.4V30.6C34 30.04 34 29.7599 33.891 29.546C33.7951 29.3579 33.6422 29.2049 33.454 29.109C33.2401 29 32.9601 29 32.4 29H17.6C17.0399 29 16.7599 29 16.546 29.109C16.3578 29.2049 16.2049 29.3579 16.109 29.546C16 29.7599 16 30.04 16 30.6ZM24.6529 15.0772L17.2529 16.7216C16.8059 16.8209 16.5823 16.8706 16.4155 16.9908C16.2683 17.0969 16.1527 17.2409 16.0811 17.4076C16 17.5965 16 17.8255 16 18.2835L16 19.4C16 19.9601 16 20.2401 16.109 20.454C16.2049 20.6422 16.3578 20.7952 16.546 20.891C16.7599 21 17.0399 21 17.6 21H32.4C32.9601 21 33.2401 21 33.454 20.891C33.6422 20.7952 33.7951 20.6422 33.891 20.454C34 20.2401 34 19.9601 34 19.4V18.2835C34 17.8255 34 17.5965 33.9188 17.4076C33.8473 17.2409 33.7317 17.0969 33.5845 16.9908C33.4177 16.8706 33.1942 16.8209 32.7471 16.7216L25.3471 15.0772C25.2176 15.0484 25.1528 15.034 25.0874 15.0282C25.0292 15.0231 24.9708 15.0231 24.9126 15.0282C24.8472 15.034 24.7824 15.0484 24.6529 15.0772Z",
    stroke: "#6B7280",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddi_1140_30797",
    x: 0,
    y: 1,
    width: 52,
    height: 57,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1140_30797"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1140_30797",
    result: "effect2_dropShadow_1140_30797"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1140_30797",
    result: "effect3_dropShadow_1140_30797"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1140_30797",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect4_innerShadow_1140_30797"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewbankicon);
export default __webpack_public_path__ + "static/media/newbankicon.dfbafa6a5acca12b5cddbf061b8d0e02.svg";
export { ForwardRef as ReactComponent };